import React from 'react';
import PropTypes from 'prop-types';

export default function renderField({
  input,
  placeholder,
  type,
  maxLength,
  disabled,
  pattern,
  min,
  max,
  meta: { touched, error, submitFailed },
  style,
  readOnly,
  onKeyPress,
}) {
  const inputRef = React.useRef(null);
  const setInputFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const clearInputRef = () => {
    inputRef.current = null;
  };

  const sanitizeValue = (event) => {
    const reassign = event;
    reassign.target.value = event.target.value.trimStart();
    return reassign;
  };

  return (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      {type === 'textarea' ? (
        <textarea
          {...input}
          placeholder={placeholder}
          type={type}
          onChange={(event) => {
            input.onChange(sanitizeValue(event));
          }}
          maxLength={maxLength}
          disabled={disabled}
          pattern={pattern}
          min={min}
          max={max}
          style={style}
          readOnly={readOnly}
          onKeyPress={onKeyPress}
        />
      ) : (
        <input
          {...input}
          placeholder={placeholder}
          type={type}
          onChange={(event) => {
            input.onChange(sanitizeValue(event));
          }}
          maxLength={maxLength}
          disabled={disabled}
          pattern={pattern}
          min={min}
          max={max}
          style={style}
          readOnly={readOnly}
          onKeyPress={onKeyPress}
          ref={inputRef}
        />
      )}
      {touched && error && (
        <span className="form__form-group-error">{error}</span>
      )}
      {submitFailed && error && (
        <span className="form__form-group-error">
          {error}
          {setInputFocus()}
          {clearInputRef()}
        </span>
      )}
    </div>
  );
}

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.string,
  disabled: PropTypes.bool,
  pattern: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.shape, PropTypes.array]),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  readOnly: PropTypes.bool,
  onKeyPress: PropTypes.func,
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
  disabled: false,
  maxLength: '9999999',
  pattern: null,
  min: null,
  max: null,
  style: null,
  readOnly: null,
  onKeyPress: null,
};
